import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { ActivatedRoute, Router } from '@angular/router';
import { BreadcrumbService } from '../../../../domain/services/breadcrumb/breadcrumb.service';
import { AppraiserOfficeService } from '../../../../domain/services/appraiser-office/appraiser-office.service';

@Component({
  selector: 'app-appraiser-office-form',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
  ],
  templateUrl: './appraiser-office-form.component.html',
  styleUrl: './appraiser-office-form.component.css',
})
export class AppraiserOfficeFormComponent implements OnInit {
  form!: FormGroup;
  isEditMode = false;
  officeId: number | null = null;

  get subtitle(): string {
    return this.isEditMode ? 'Edit appraiser office' : 'Create a new appraiser office';
  }

  constructor(
    private readonly fb: FormBuilder,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly breadcrumbService: BreadcrumbService,
    private readonly service: AppraiserOfficeService
  ) {}

  ngOnInit(): void {
    this.breadcrumbService.updateBreadcrumbs([
      { icon: 'account_balance', url: '/app/admin/appraiser-offices', label: 'Administrative' },
      { icon: 'apartment', url: '/app/admin/appraiser-offices', label: 'Appraiser offices' },
    ]);

    this.form = this.fb.group({
      name: ['', Validators.required],
      officeNumber: [''],
      county: [''],
      active: [true],
    });

    const idParam = this.route.snapshot.params['id'];
    if (idParam && idParam !== 'new') {
      this.isEditMode = true;
      this.officeId = Number(idParam);
      this.service.getById(this.officeId).subscribe((office) => {
        if (office) {
          this.form.patchValue({
            name: office.name,
            officeNumber: office.officeNumber ?? '',
            county: office.county ?? '',
            active: office.active,
          });
        }
      });
    }
  }

  onSave(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    const payload = this.form.value;
    const done = () => this.router.navigate(['/app/admin/appraiser-offices']);
    if (this.isEditMode && this.officeId !== null) {
      this.service.update(this.officeId, payload).subscribe(done);
    } else {
      this.service.create(payload).subscribe(done);
    }
  }

  goBack(): void {
    this.router.navigate(['/app/admin/appraiser-offices']);
  }
}
